import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import * as entityTypes from 'v1/helpers/entityTypes';

import { getStatuses } from 'store/v1/statuses/statuses.selectors.js';
import {
  DropdownMenu,
  DropdownMenuButtonArrow,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from 'v5/design-system/DropdownMenu.js';
import { Button } from 'v5/design-system/Button.js';
import { Check, ChevronLeft } from 'lucide-react';

const BookResourceFlyoverBookingFooter = ({ saveBooking, onBackClick }) => {
  const statuses = useSelector(state =>
    getStatuses(state, { entity_type: entityTypes.BOOKING })
  );
  const confirmedStatus = useSelector(state =>
    get(
      getStatuses(state, {
        status_type: 'CONFIRMED',
        entity_type: entityTypes.BOOKING
      }),
      '0'
    )
  );

  return (
    <div className="text-fg-muted flex items-center gap-2 w-full">
      <Button variant="ghost" size="sm" onClick={onBackClick}>
        <ChevronLeft />
        Back
      </Button>
      <div className="ml-auto">Save as</div>
      <Button
        variant="success"
        size="sm"
        onClick={() => saveBooking(confirmedStatus)}
      >
        <Check />
        Confirmed
      </Button>
      <div>or</div>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="secondary" size="sm">
            Other
            <DropdownMenuButtonArrow />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {statuses.map(status => (
            <DropdownMenuItem
              key={status.id}
              onSelect={() => {
                window.requestAnimationFrame(() => {
                  setTimeout(() => {
                    saveBooking(status);
                  }, 500); // https://github.com/radix-ui/primitives/issues/3445
                });
              }}
            >
              {status.name}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

BookResourceFlyoverBookingFooter.propTypes = {
  saveBooking: PropTypes.func
};

export default BookResourceFlyoverBookingFooter;
